const POLL_INTERVAL_MS = 60000

/**
 * Состояние инцидента с СМС: бэкенд поднимает флаг, когда подряд не удалось
 * отправить СМС на несколько разных номеров, и снимает его после первой
 * успешной отправки.
 */
export function useSmsIncident() {
  const {apiQuery} = useApi()

  const isSmsIncidentActive = useState('sms-incident-active', () => false)

  async function fetchSmsIncident() {
    try {
      const response = await apiQuery<{ active: boolean }>('/public/sms-incident', 'GET', {})
      isSmsIncidentActive.value = response.active
    } catch {
      // Баннер — вспомогательная информация: если статус недоступен, тревожить не за что.
      isSmsIncidentActive.value = false
    }
  }

  /**
   * Пока баннер висит, опрашиваем статус: инцидент должен закрыться сам, без
   * перехода по страницам — пользователь ждёт СМС на той же странице.
   */
  function watchSmsIncident() {
    let timer: ReturnType<typeof setInterval> | null = null

    const stopPolling = () => {
      if (timer) {
        clearInterval(timer)
        timer = null
      }
    }

    watch(isSmsIncidentActive, (isActive) => {
      if (isActive && !timer) {
        timer = setInterval(fetchSmsIncident, POLL_INTERVAL_MS)
        return
      }

      if (!isActive) {
        stopPolling()
      }
    })

    onScopeDispose(stopPolling)
  }

  return {isSmsIncidentActive, fetchSmsIncident, watchSmsIncident}
}
